var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FDCA40"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.987c.007 3.857-3.138 7.01-6.995 7.013a6.97 6.97 0 0 1-4.398-1.55.677.677 0 0 1-.052-1.005l.318-.318a.679.679 0 0 1 .9-.056A5.172 5.172 0 0 0 12 17.194 5.19 5.19 0 0 0 17.194 12 5.19 5.19 0 0 0 12 6.806c-1.378 0-2.63.536-3.558 1.41l1.432 1.432a.452.452 0 0 1-.32.771H5.453A.452.452 0 0 1 5 9.968V5.864c0-.402.486-.603.771-.319L7.165 6.94A7 7 0 0 1 19 11.987zm-5.106 2.223.277-.356a.677.677 0 0 0-.119-.95l-1.149-.894V9.065a.677.677 0 0 0-.677-.678h-.452a.677.677 0 0 0-.677.678v3.828l1.846 1.436c.295.23.72.177.95-.119z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchActivity);
export default ForwardRef;